/** ODA BimRv JSON hierarchy: retain actual source IDs and property groups. */
export function nativeInventory(data){
 const objects=Object.create(null),levels=[],stack=[data];
 while(stack.length){const value=stack.pop();if(!value||typeof value!=='object')continue;
  if(value.object&&typeof value.name==='string'){
   const id=String(value.object),groups=Object.create(null);for(let i=0;i<(value.properties?.length||0);i+=2){const name=value.properties[i],properties=value.properties[i+1];if(typeof name==='string'&&properties&&typeof properties==='object')groups[name]=properties;}
   objects[id]={id,type:value.name,externalId:value.externalId||'',properties:groups};
   if(value.name==='OdBmLevel'){
    const elevation=Number(groups.Constraints?.Elevation),name=groups['Identity Data']?.Name;
    if(Number.isFinite(elevation)&&typeof name==='string')levels.push({id,name,elevation,source:'ODA-BimRv-JSON',externalId:value.externalId||''});
   }
  }
  for(const child of Object.values(value))if(child&&typeof child==='object')stack.push(child);
 }
 return {objects,levels:levels.sort((a,b)=>a.elevation-b.elevation),levelUnits:'source-document-display-unverified',references:[]};
}

/** Infer only from exact Level IDs and planar model geometry; never from overall extents. */
export function inferLevelTransform(levels,objects,tolerance=.002){
 const source=new Map(levels.map(l=>[String(l.id),l])),groups=new Map();
 for(const object of objects||[]){const id=String(object.properties?.handle??object.properties?.ElementId??''),level=source.get(id),box=object.bbox;if(!level||!box||Math.abs(box.max[2]-box.min[2])>tolerance)continue;const values=groups.get(id)||[];values.push((box.min[2]+box.max[2])/2);groups.set(id,values);}
 const points=[];for(const [id,values]of groups){if(Math.max(...values)-Math.min(...values)>tolerance)continue;points.push([source.get(id).elevation,values.reduce((a,b)=>a+b,0)/values.length]);}
 if(points.length<2)return null;
 const x=points.reduce((s,p)=>s+p[0],0)/points.length,y=points.reduce((s,p)=>s+p[1],0)/points.length;
 const variance=points.reduce((s,p)=>s+(p[0]-x)**2,0);if(!variance)return null;
 const scale=points.reduce((s,p)=>s+(p[0]-x)*(p[1]-y),0)/variance,offset=y-scale*x;
 if(!(scale>0)||!Number.isFinite(scale)||points.some(p=>Math.abs(p[1]-(p[0]*scale+offset))>tolerance))return null;
 return {scale,offset,count:points.length};
}

export function drawingInventory(records,tree){
 const names=new Map(),stack=Array.isArray(tree)?[...tree]:[tree];while(stack.length){const node=stack.pop();if(!node||typeof node!=='object')continue;if(node.handle!==undefined)names.set(String(node.handle),node.name||'DWG entity');for(const child of node.children||[])stack.push(child);}
 const objects=Object.create(null);for(const record of records){const id=String(record.handle);objects[id]={id,type:names.get(id)||'DWG entity',externalId:'',properties:{原始屬性:record}};}
 return {objects,levels:[],references:[],levelUnits:'not-applicable'};
}

/** FileConverter .properties uses the same ElementId handles as GLB extras. */
export function revitPropertiesInventory(records, tree) {
 if(!Array.isArray(records)||!Array.isArray(tree))throw new Error('無效的 RVT properties 結構');
 const payload=drawingInventory(records.filter(row=>row&&row.handle!==undefined&&String(row.handle)!=='0'),tree);
 for(const object of Object.values(payload.objects)){
  const record=object.properties['原始屬性'];
  object.properties={Revit:record};
  object.externalId=String(record.IfcGUID||record.IfcGuid||'');
 }
 return {...payload,source:'ODA-FileConverter-properties',levelUnits:'source-document-display-unverified'};
}
